import type { IPlace } from "@bbj-types/address";
import type { OrientationType } from "@bbj-types/team/enum";
import type { ObjectId } from "@bbj-types/utils";
import { buildMakeUseAxios } from "@root/api/api.tools";
import { useCallback } from "react";

const teamsAxios = buildMakeUseAxios(`${import.meta.env.VITE_SETTING_SERVICE_URL}/teams`);

export interface IGetTeamResponse {
  _id: ObjectId;
  organisation: ObjectId;
  name: string;
  defaultCer: ObjectId;
  place: IPlace;
  externalId?: string;
  showConvocation: boolean;
  type: OrientationType[];
  createdAt: Date;
  updatedAt: Date;
}

export const useGetTeams = () => {
  const [state, execute, cancel] = teamsAxios<IGetTeamResponse[]>(
    {
      url: "",
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(() => {
    return execute();
  }, [execute]);

  return [state, callback, cancel] as const;
};
